import { Link } from 'react-router-dom';
import { LIVE_TOOLS, TOOL_CATEGORIES } from '../data/tools';

export default function ToolCategories() {
  return (
    <section className="py-20 px-4 border-t border-gray-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 text-center">Browse by Category</h2>
        <p className="mt-3 text-center text-gray-600 max-w-xl mx-auto">
          Organized collections of our live utilities — more categories as new tools ship.
        </p>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {TOOL_CATEGORIES.map((cat) => {
            const tools = cat.toolIds.map((id) => LIVE_TOOLS.find((t) => t.id === id)).filter(Boolean);
            return (
              <div key={cat.name} className="rounded-2xl border border-gray-100 p-6 bg-gray-50/30">
                <h3 className="font-semibold text-gray-900 text-lg">{cat.name}</h3>
                <p className="mt-2 text-sm text-gray-500">{cat.description}</p>
                <ul className="mt-4 space-y-2">
                  {tools.map((tool) => (
                    <li key={tool.id}>
                      <Link to={tool.landingPath} className="text-sm text-brand-600 hover:underline font-medium">
                        {tool.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
